import { fromJS, Map, List } from 'immutable'
import actionTypes from '../actions/actionTypes'

const INIT_STATE = Map({
    presets:       List([]),
    isLoading:     false,
    isDownloading: false,
    error:         null,
})

const socialMediaReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case actionTypes.SOCIAL_MEDIA_PRESETS_GET_REQUEST:
            return state.set('isLoading', true).set('error', null)

        case actionTypes.SOCIAL_MEDIA_PRESETS_GET_SUCCESS:
            return state
                .set('isLoading', false)
                .set('presets', fromJS(action.payload))

        case actionTypes.SOCIAL_MEDIA_PRESETS_GET_ERROR:
            return state
                .set('isLoading', false)
                .set('error', action.payload)

        case actionTypes.SOCIAL_MEDIA_PRESET_CREATE_SUCCESS:
            return state.update('presets', presets => presets.push(fromJS(action.payload)))

        case actionTypes.SOCIAL_MEDIA_PRESET_UPDATE_SUCCESS:
            return state.update('presets', presets =>
                presets.map(p =>
                    p.get('id') === action.payload.id ? fromJS(action.payload) : p
                )
            )

        case actionTypes.SOCIAL_MEDIA_PRESET_DELETE_SUCCESS:
            return state.update('presets', presets =>
                presets.filter(p => p.get('id') !== action.payload.id)
            )

        case actionTypes.SOCIAL_MEDIA_DOWNLOAD_REQUEST:
            return state.set('isDownloading', true)

        case actionTypes.SOCIAL_MEDIA_DOWNLOAD_SUCCESS:
        case actionTypes.SOCIAL_MEDIA_DOWNLOAD_ERROR:
            return state.set('isDownloading', false)

        default:
            return state
    }
}

export default socialMediaReducer
